import type { AxiosResponse } from "axios";
import type { HttpClient } from "@/services/baseClient";
import type {
  ApiResponse,
  ApiKeyRecord,
  CreateApiKeyRequest,
  CreateApiKeyResponse,
} from "@/types";

export function createApiKeysApi({ client }: HttpClient) {
  return {
    async getApiKeys(): Promise<ApiKeyRecord[]> {
      const response: AxiosResponse<ApiResponse<ApiKeyRecord[]>> =
        await client.get("/auth/apikeys");
      return response.data.data;
    },

    async createApiKey(data: CreateApiKeyRequest): Promise<CreateApiKeyResponse> {
      const response: AxiosResponse<ApiResponse<CreateApiKeyResponse>> =
        await client.post("/auth/apikeys", data);
      return response.data.data;
    },

    async revokeApiKey(id: string): Promise<void> {
      await client.delete(`/auth/apikeys/${id}`);
    },
  };
}
